import React from "react";
import { Box, Grid, Collapse, Card } from "@mui/material";
import ActiveFilters from "../../../../Components/filters/ActiveFilters";
import { formatDateRange } from "../../../../Utils/DateUtils";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "code",
      label: "Stock Code",
      value: submittedData.code,
    },
    {
      type: "standard",
      id: "description",
      label: "Description",
      value: submittedData.description,
    },
    {
      type: "standard",
      id: "active",
      label: "Active",
      value: submittedData.active,
    },
    {
      type: "numericRange",
      id: "inventory",
      label: "Qty",
      minValue: submittedData.inventoryMin,
      maxValue: submittedData.inventoryMax,
    },
    {
      type: "numericRange",
      id: "thresholdValue",
      label: "Threshold Value",
      minValue: submittedData.thresholdValueMin,
      maxValue: submittedData.thresholdValueMax,
    },
    {
      type: "standard",
      id: "bayLocation",
      label: "Bay Location",
      value: submittedData.bayLocation,
    },
    {
      type: "dateRange",
      id: "lastSynced",
      label: "Last Synced",
      startValue: submittedData.lastSyncedStart,
      endValue: submittedData.lastSyncedEnd,
    },
  ];

  // Helper function to remove date range filters
  const handleRemoveDateRange = (rangeId) => {
    if (rangeId === "lastSynced") {
      handleRemove("lastSyncedStart");
      handleRemove("lastSyncedEnd");
    }
  };

  // Helper function to remove numeric range filters
  const handleRemoveNumericRange = (rangeId) => {
    if (rangeId === "orderLine") {
      handleRemove("orderLineMin");
      handleRemove("orderLineMax");
    } else if (rangeId === "inventory") {
      handleRemove("inventoryMin");
      handleRemove("inventoryMax");
    } else if (rangeId === "thresholdValue") {
      handleRemove("thresholdValueMin");
      handleRemove("thresholdValueMax");
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
              />
            </Box>
          </Card>
        </Collapse>
      </Grid>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
        onRemoveDateRange={handleRemoveDateRange}
        onRemoveNumericRange={handleRemoveNumericRange}
        formatDateRange={formatDateRange}
      />
    </>
  );
};

export default Filter;
